function check_hidden_inputs(elm) {
    if (!$(elm).is(":checked")) {
        $("#" + $(elm).attr("data-box")).addClass("hide");
    }
    else {
        $("#" + $(elm).attr("data-box")).removeClass("hide");
    }
}

Event.on('Cart.product.updated', function(response) {
    window.location.reload();
});

$(function() {
    // modules
    tippy('.js-tippy-demro');

    $('.js-form-cart-modules .cart-modules__item [type=radio]').on('change', function() {
        const $this = $(this);

        $this.parents('.cart-modules__item').find('.cart-modules__item__collapse.collapsed').trigger('click');
    });

    $('.js-form-cart-modules').on('submit', function(event) {
        let result = true;

        $('#error-shipping').empty().html( $('#error-shipping').data('error-msg') );

        if (!$('[name="payment_id"]').not('[data-disabled="true"]').is(':checked')) {
            $('#error-payment').fadeIn(500);
            result = false;
        } else {
            if ($('#error-payment').is(':visible')) { $('#error-payment').fadeOut(500); }
        }

        if (!$('[name="shipping_id"]').is(':checked')) {
            $('#error-shipping').fadeIn(500);
            result = false;
        } else if ($('[name="shipping_id"]:checked').val() == 3) {
            const $cityInput = $('[name="city"]'),
                $shippingModuleInput = $('[name="shipping_module_id"]');

            if ($cityInput.is(':visible') && $shippingModuleInput.is(':visible')) {
                if ($shippingModuleInput.val() == 0 || $cityInput.val() == 0) {
                    if ($shippingModuleInput.val() == 0) {
                        $('#error-shipping').empty().html( $shippingModuleInput.data('error-msg') );
                    }

                    if ($cityInput.val() == 0) {
                        $('#error-shipping').empty().html( $cityInput.data('error-msg') );
                    }

                    $('#error-shipping').fadeIn(500);
                    result = false;
                } else {
                    $('#error-shipping').fadeOut(500);
                }
            } else {
                $('#error-shipping').fadeIn(500);
                result = false;
            }
        } else {
            if ($('#error-shipping').is(':visible')) { $('#error-shipping').fadeOut(500); }
        }

        if (!result) {
            $('.c-msg--error').slideHere();
        }

        return result;
    });

    if ($('input[name="payment_id"][data-disabled="true"]:checked').length) {
        $('input[name="payment_id"][data-disabled="true"]:checked').prop('checked', false).trigger('change');
    }

    // form
    if ($('.js-form-reg').length > 0) {
        check_hidden_inputs($("#order-registered, #customer-registered"));

        $("#order-registered, #customer-registered").change(function () {
            check_hidden_inputs($(this));
        });
    }

    $('.js-form-page-login').validate({
        rules: {
            login: {
                email: true
            }
        },
        submitHandler: function (form) {
            form.submit();
        }
    });

    // confirm
    $('.js-form-cart-confirm').validate({
        errorPlacement: function(error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            form.submit();

            $('.js-order-submit')
                .prop('disabled', true)
                .addClass('is-loading');
        }
    });

    $('.js-vouchers-form').validate();
    $('.js-points-form').validate({
        submitHandler: function (form) {
            $('#cart-points-amount').val($('#fake-cart-points-amount').val() * 100);
            form.submit();
        }
    });

    $('.js-toggle-voucher').on('click', function() {
        $('#cart-vouchers').stop(true).slideToggle(250);

        requestAnimationFrame(function() {
            $('[name="voucher"]').focus();
        })
    });

    $('.js-toggle-points').on('click', function() {
        $(this).hide();
        $('#points-form').show();

        requestAnimationFrame(function() {
            $('[name="fake_points_used"]').focus();
        })
    });
});
